document.addEventListener('DOMContentLoaded', function () {
  applyDefaultPageRuntimeTheme();

  document.querySelectorAll('a[href="/pages/calendar"],a[href="/pages/calendar?view=area27-calendar"],a[href="/pages/calendar?view=area27-calendar-live"],a[href="/pages/calendar?view=area27-calendar-staff"],a[href="/pages/calendar?view=area27-calendar-clean"],a[href="/pages/calendar?view=area27-calendar-clean-v2"]').forEach(function (link) {
    link.setAttribute('href', '/pages/calendar?view=area27-calendar-clean-v8');
  });

  if (window.location.pathname === '/pages/guest-driver-application' || window.location.pathname === '/guest-driver-application') {
    enhanceGuestDriverDatePickers();
  }

  var toggle = document.querySelector('.area27-nav-toggle');
  var nav = document.querySelector('.area27-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) closeMobileMegaMenus();
    });
  }

  var mobileHeaderQuery = window.matchMedia ? window.matchMedia('(max-width: 980px)') : null;
  var megaItems = Array.prototype.slice.call(document.querySelectorAll('.area27-nav__item--mega'));
  var desktopHeader = document.querySelector('[data-area27-header]');
  var megaPositionFrame = 0;

  megaItems.forEach(function (item, index) {
    var btn = item.querySelector('.area27-mega-toggle');
    var parentLink = item.querySelector('a');
    var menu = item.querySelector('[data-area27-mega]');
    if (!btn || !parentLink || !menu) return;

    var menuId = menu.id || 'Area27MobileMegaMenu' + (index + 1);
    menu.id = menuId;
    btn.setAttribute('aria-controls', menuId);

    btn.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      closeMobileMegaMenus(item);
      setMobileMegaState(item, open);
      scheduleDesktopMegaPosition();
    });

    item.addEventListener('pointerenter', function () {
      if (isMobileHeader()) return;
      closeMobileMegaMenus(item);
      scheduleDesktopMegaPosition();
    });

    item.addEventListener('pointerleave', function () {
      if (!isMobileHeader()) setMobileMegaState(item, false);
    });

    parentLink.addEventListener('click', function (event) {
      if (!isMobileHeader()) return;
      event.preventDefault();

      var shouldOpen = !item.classList.contains('is-open');
      closeMobileMegaMenus(item);
      setMobileMegaState(item, shouldOpen);
    });
  });

  syncMobileMegaAccessibility();
  syncDesktopMegaPosition();
  if (mobileHeaderQuery) {
    if (typeof mobileHeaderQuery.addEventListener === 'function') {
      mobileHeaderQuery.addEventListener('change', function () {
        syncMobileMegaAccessibility();
        syncDesktopMegaPosition();
      });
    } else if (typeof mobileHeaderQuery.addListener === 'function') {
      mobileHeaderQuery.addListener(function () {
        syncMobileMegaAccessibility();
        syncDesktopMegaPosition();
      });
    }
  } else {
    window.addEventListener('resize', function () {
      syncMobileMegaAccessibility();
      scheduleDesktopMegaPosition();
    });
  }

  window.addEventListener('scroll', scheduleDesktopMegaPosition, { passive: true });
  window.addEventListener('resize', scheduleDesktopMegaPosition);
  if (desktopHeader && typeof ResizeObserver === 'function') {
    new ResizeObserver(scheduleDesktopMegaPosition).observe(desktopHeader);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isMobileHeader()) closeMobileMegaMenus();
  });

  function isMobileHeader() {
    return mobileHeaderQuery ? mobileHeaderQuery.matches : window.innerWidth <= 980;
  }

  function scheduleDesktopMegaPosition() {
    if (megaPositionFrame) return;
    megaPositionFrame = window.requestAnimationFrame(function () {
      megaPositionFrame = 0;
      syncDesktopMegaPosition();
    });
  }

  function syncDesktopMegaPosition() {
    if (!desktopHeader || !megaItems.length) return;

    if (isMobileHeader()) {
      megaItems.forEach(function (item) {
        var menu = item.querySelector('[data-area27-mega]');
        if (menu) {
          menu.style.removeProperty('top');
          menu.style.removeProperty('left');
          menu.style.removeProperty('transform');
          var pointer = menu.querySelector('.area27-mega__pointer');
          if (pointer) pointer.style.removeProperty('left');
        }
      });
      return;
    }

    var headerBottom = Math.max(0, Math.floor(desktopHeader.getBoundingClientRect().bottom) - 1);
    megaItems.forEach(function (item) {
      var menu = item.querySelector('[data-area27-mega]');
      if (!menu) return;
      var link = item.querySelector(':scope > a');
      if (!link) return;
      var linkRect = link.getBoundingClientRect();
      var width = parseFloat(window.getComputedStyle(menu).width) || 640;
      var center = linkRect.left + linkRect.width / 2;
      var left = Math.max(16, Math.min(window.innerWidth - width - 16, center - width / 2));
      menu.style.top = headerBottom + 'px';
      menu.style.setProperty('left', left + 'px', 'important');
      menu.style.setProperty('transform', 'none', 'important');
      var pointer = menu.querySelector('.area27-mega__pointer');
      if (pointer) pointer.style.setProperty('left', (center - left) + 'px', 'important');
    });
  }

  function setMobileMegaState(item, open) {
    var parentLink = item.querySelector('a');
    var btn = item.querySelector('.area27-mega-toggle');
    item.classList.toggle('is-open', open);
    if (parentLink) parentLink.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeMobileMegaMenus(except) {
    megaItems.forEach(function (item) {
      if (item !== except) setMobileMegaState(item, false);
    });
  }

  function syncMobileMegaAccessibility() {
    megaItems.forEach(function (item) {
      var parentLink = item.querySelector('a');
      var btn = item.querySelector('.area27-mega-toggle');
      if (!parentLink) return;

      if (isMobileHeader()) {
        if (btn) {
          btn.style.setProperty('display', 'none', 'important');
          btn.setAttribute('aria-hidden', 'true');
          btn.setAttribute('tabindex', '-1');
        }
        parentLink.setAttribute('aria-haspopup', 'true');
        parentLink.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      } else {
        item.classList.remove('is-open');
        parentLink.removeAttribute('aria-haspopup');
        parentLink.removeAttribute('aria-expanded');
        if (btn) {
          btn.style.removeProperty('display');
          btn.removeAttribute('aria-hidden');
          btn.removeAttribute('tabindex');
          btn.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  function applyDefaultPageRuntimeTheme() {
    if (document.getElementById('a27-default-page-runtime')) return;
    if (document.querySelector('[data-a27-calendar-root], [data-a27-editor-root], #Area27GuestDriverApplicationForm')) return;
    if (!document.querySelector('#MainContent > .shopify-section.section-wrapper .shopify-block.rte .page-content')) return;

    var style = document.createElement('style');
    style.id = 'a27-default-page-runtime';
    style.textContent = [
      '#MainContent > .shopify-section.section-wrapper{position:relative!important;isolation:isolate!important;overflow:hidden!important;background:#020303!important;color:#f7f4ec!important}',
      '#MainContent > .shopify-section.section-wrapper > .section-background{position:absolute!important;inset:0!important;z-index:0!important;background:linear-gradient(90deg,rgba(0,0,0,.9),rgba(0,0,0,.72) 48%,rgba(0,0,0,.84)),linear-gradient(180deg,rgba(0,0,0,.72),rgba(0,0,0,.92)),url("https://cdn.shopify.com/s/files/1/0814/4909/1318/files/JV_f1_racing.png?v=1784009162") center top/cover no-repeat!important;opacity:1!important}',
      '#MainContent > .shopify-section.section-wrapper > .section.page-width-content{position:relative!important;z-index:1!important;width:min(1240px,calc(100% - 72px))!important;max-width:1240px!important;margin-inline:auto!important;padding-inline:0!important;background:transparent!important;color:#f7f4ec!important}',
      '#MainContent > .shopify-section.section-wrapper .section-content-wrapper,#MainContent > .shopify-section.section-wrapper .text-block,#MainContent > .shopify-section.section-wrapper .shopify-block.rte,#MainContent > .shopify-section.section-wrapper .page-content{width:100%!important;max-width:100%!important;margin-inline:auto!important}',
      '#MainContent > .shopify-section.section-wrapper .color-custom-template--22099417497846__main,#MainContent > .shopify-section.section-wrapper .color-custom-template--22099417497846__main .text-block{--color-background:transparent!important;--color-background-rgb:2 3 3!important;--color:#f7f4ec!important;--color-rgb:247 244 236!important;--color-foreground:#f7f4ec!important;--color-foreground-rgb:247 244 236!important;--color-foreground-muted:rgba(247,244,236,.76)!important;--color-foreground-subdued:rgba(247,244,236,.62)!important;--color-border:rgba(255,255,255,.18)!important;background-color:transparent!important;color:#f7f4ec!important}',
      '#MainContent > .shopify-section.section-wrapper .text-block h1{color:#fff!important;font-size:clamp(2.2rem,3.4vw,4rem)!important;line-height:1.06!important;letter-spacing:0!important}',
      '#MainContent > .shopify-section.section-wrapper .rte{color:rgba(247,244,236,.88)!important;font-size:clamp(1rem,1.04vw,1.12rem)!important;line-height:1.68!important}',
      '#MainContent > .shopify-section.section-wrapper .rte img{display:block!important;width:100%!important;max-width:100%!important;height:auto!important;margin:0 auto clamp(22px,3vw,34px)!important}',
      '#MainContent > .shopify-section.section-wrapper .rte h2,#MainContent > .shopify-section.section-wrapper .rte h3{color:#fff!important;margin:clamp(24px,3vw,38px) 0 12px!important;line-height:1.15!important;letter-spacing:0!important}',
      '#MainContent > .shopify-section.section-wrapper .rte p,#MainContent > .shopify-section.section-wrapper .rte ul,#MainContent > .shopify-section.section-wrapper .rte ol,#MainContent > .shopify-section.section-wrapper .rte blockquote{max-width:980px!important}',
      '#MainContent > .shopify-section.section-wrapper .rte blockquote{color:#fff!important;border-left:3px solid #d2a246!important;padding-left:18px!important}',
      '#MainContent > .shopify-section.section-wrapper .rte hr{border-color:rgba(255,255,255,.22)!important;margin:clamp(24px,3vw,38px) 0!important}',
      '@media(max-width:700px){#MainContent > .shopify-section.section-wrapper > .section.page-width-content{width:min(100% - 32px,1240px)!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function enhanceGuestDriverDatePickers() {
    var form = document.getElementById('Area27GuestDriverApplicationForm');
    if (!form) return;

    if (!document.getElementById('a27-gda-date-picker-fallback')) {
      var style = document.createElement('style');
      style.id = 'a27-gda-date-picker-fallback';
      style.textContent = [
        '.a27-gda__date-control{display:grid;grid-template-columns:minmax(0,1fr)52px;gap:10px;align-items:stretch}',
        '.a27-gda__date-button{display:inline-flex;width:52px;min-height:50px;align-items:center;justify-content:center;border:1px solid rgba(33,200,223,.55);border-radius:4px;background:rgba(33,200,223,.08);color:#21c8df;cursor:pointer;padding:0}',
        '.a27-gda__date-button:hover,.a27-gda__date-button:focus-visible{background:rgba(33,200,223,.16);outline:2px solid rgba(33,200,223,.45);outline-offset:2px}',
        '.a27-gda__calendar-icon{position:relative;display:block;width:22px;height:22px;border:2px solid currentColor;border-radius:4px}',
        '.a27-gda__calendar-icon:before,.a27-gda__calendar-icon:after{content:"";position:absolute;left:3px;right:3px;background:currentColor}',
        '.a27-gda__calendar-icon:before{top:5px;height:2px}',
        '.a27-gda__calendar-icon:after{top:-5px;left:4px;right:4px;height:7px;background:transparent;border-left:2px solid currentColor;border-right:2px solid currentColor}'
      ].join('');
      document.head.appendChild(style);
    }

    [
      ['A27RequestedTrackDate', 'Open calendar for Requested Track Date'],
      ['A27License1ExpiryDate', 'Open calendar for Licence 1 Expiry Date'],
      ['A27License2ExpiryDate', 'Open calendar for Licence 2 Expiry Date'],
      ['A27Accreditation1Date', 'Open calendar for Accreditation 1 Date Of Completion'],
      ['A27Accreditation2Date', 'Open calendar for Accreditation 2 Date Of Completion']
    ].forEach(function (item) {
      var input = document.getElementById(item[0]);
      if (!input) {
        var selector = '';
        if (item[0] === 'A27License1ExpiryDate') selector = 'input[name="contact[License 1 Expiry Date]"]';
        if (item[0] === 'A27License2ExpiryDate') selector = 'input[name="contact[License 2 Expiry Date]"]';
        if (item[0] === 'A27Accreditation1Date') selector = 'input[name="contact[Accreditation 1 Date]"]';
        if (item[0] === 'A27Accreditation2Date') selector = 'input[name="contact[Accreditation 2 Date]"]';
        input = selector ? form.querySelector(selector) : null;
        if (input) input.id = item[0];
      }
      if (!input || input.closest('.a27-gda__date-control')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'a27-gda__date-control';
      input.parentNode.insertBefore(wrapper, input);
      wrapper.appendChild(input);

      var button = document.createElement('button');
      button.className = 'a27-gda__date-button';
      button.type = 'button';
      button.setAttribute('aria-label', item[1]);
      button.title = 'Open calendar';
      button.innerHTML = '<span class="a27-gda__calendar-icon" aria-hidden="true"></span>';
      button.addEventListener('click', function () {
        input.focus();
        if (typeof input.showPicker === 'function') {
          try {
            input.showPicker();
          } catch (error) {}
        }
      });
      wrapper.appendChild(button);
    });
  }
});
